import greySpinner from '../assets/animations/grey-spiner.json';
// import spinnerLoading from '../assets/animations/spinner.json';
// import splashLoading from '../assets/animations/splash.json';
import { ReactComponent as AnswerCirculationCard } from '../assets/img/icon/AnswerWhite.svg';
import { ReactComponent as GaliciaCirculationCard } from '../assets/img/icon/GaliciaWhite.svg';
// import GaliciaCirculationCard from '../assets/img/logos/img_logo_galicia_white.png';
import answerLogo from '../assets/img/logos/answer_logo.png';
import galiciaLogo from '../assets/img/logos/img_logo_galicia.png';
import galiciaLogoInline from '../assets/img/logos/img_logo_galicia_2.png';

import LoginAnswer from '../screens/PublicLayout/Login/Answer';
import LoginPatagonia from '../screens/PublicLayout/Login/Patagonia';
import LoginSura from '../screens/PublicLayout/Login/Sura';
import RegisterAnswer from '../screens/PublicLayout/Register/Answer';
import RegisterSura from '../screens/PublicLayout/Register/Sura';

// In this object we locate config cross-apps
const common = {
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  APIS: {
    BASE_NEW: process.env.REACT_APP_API_BASE_URL,
    BASE_BFF: process.env.REACT_APP_API_BFF,
  },
  // ASSISTANCE_FORMATED_PHONE: '0800 999 76925',
  ASSISTANCE_PHONE_LINK: 'tel:080099976925',
  TYPOGRAPHY: {
    fontFamily: 'Inter, Barlow, Roboto, sans-serif, Open Sans',
    // fontFamily: 'Barlow, Roboto, sans-serif, Open Sans, Inter',
    h3: {
      fontStyle: 'normal',
      fontSize: 20,
      lineHeight: '24px',
    },
    h4: {
      fontStyle: 'normal',
      fontSize: 18,
      lineHeight: '22px',
    },
    // h6: {
    //   fontWeight: 'bold',
    // },
    // c1
    body1: {
      fontStyle: 'normal',
      fontSize: 16,
      lineHeight: '18px',
    },
    // c2
    body2: {
      fontStyle: 'normal',
      fontSize: 14,
      lineHeight: '16px',
    },
  },
};

const config = {
  SURA: {
    // GALICIA
    ...common,
    NAME: 'Seguros Sura',
    SHORT_NAME: 'SURA',

    ASSISTANCE_PHONE: '08005552272',
    CONTACT_PHONE: '08005559998',
    WHATSAPP: '5491132548281',

    FORMATED_ASSISTANCE_PHONE: '0800-555-2272',
    FORMATED_CONTACT_PHONE: '0800-555-9998',
    FORMATED_WHATSAPP: '11-3254-8281',

    WHATSAPP_LINK: 'https://api.whatsapp.com/send?phone=5491132548281',
    EMAIL: 'infogalicia@galiciaseguros.com.ar',

    CLIENT_PHONE: 'tel:08009997692', // no se usa en otra parte del codigo
    CONTACT_PHONES: [
      {
        number: '08009997692',
        display: '0800-999-7692',
      },
    ],
    WEBSITE: 'www.sura.com.ar',
    ALTERNATIVE_NAME: 'Answer Seguros',
    ALTERNATIVE_WEBSITE: 'https://sucursaldigital.answerseguros.com.ar/login',
    ALTERNATIVE_POLICIES: 'Sucursal digital',
    IMAGES: {
      HOME_HEADER: galiciaLogo,
      APP_HEADER: galiciaLogoInline,
      CIRCULATION_CARD: GaliciaCirculationCard,
      LOADING: greySpinner, // spinnerLoading,
      DELTA_ICON: greySpinner, // spinnerLoading,
    },
    LOGIN_PAGE: LoginSura,
    REGISTER_PAGE: RegisterSura,
    LOADER: {
      BACKGROUND_COLOR: 'rgba(255, 255, 255, 0.9)',
      ACTION_COLOR: 'primary',
    },
    PALETTE: {
      primary: {
        main: '#FA6400',
        light: '#FEE0CC',
      },
      secondary: {
        main: '#A84308',
        contrastText: '#FFF',
      },
      background: {
        default: '#F1F3F8',
        paper: '#FFF',
      },
      text: {
        primary: '#000',
        // primary: '#FA6400',
        secondary: '#4D4D4D',
        // secondary: '#2B2B2B',
        disabled: '#6A6A6A',
      },
    },
  },
  ANSWER: {
    ...common,
    NAME: 'Answer Seguros',
    SHORT_NAME: 'ANSWER',

    ASSISTANCE_PHONE: '080099976925',
    CONTACT_PHONE: '08004440352',
    WEBSITE: 'www.answerseguros.com.ar',
    WHATSAPP: '5491137650687',

    FORMATED_ASSISTANCE_PHONE: '0800-999-76925',
    FORMATED_CONTACT_PHONE: '0800-444-0352',
    FORMATED_WHATSAPP: '11-3765-0687',

    EMAIL: 'answer.seguros@galiciaseguros.com.ar',
    WHATSAPP_LINK: 'https://api.whatsapp.com/send?phone=5491137650687',

    CLIENT_PHONE: 'tel:08009997692', // no se usa en otra parte del codigo
    CONTACT_PHONES: [
      {
        number: '08009997692',
        display: '0800-999-7692',
      },
      {
        number: '43198800',
        display: '4319-8800',
      },
    ],
    ALTERNATIVE_NAME: 'Seguros Sura',
    ALTERNATIVE_WEBSITE: 'https://mispolizas.galiciaseguros.com.ar/',
    ALTERNATIVE_POLICIES: 'Mis pólizas',
    IMAGES: {
      HOME_HEADER: answerLogo,
      APP_HEADER: answerLogo,
      CIRCULATION_CARD: AnswerCirculationCard,
      LOADING: greySpinner, // splashLoading,
    },
    LOGIN_PAGE: LoginAnswer,
    REGISTER_PAGE: RegisterAnswer,
    LOADER: {
      BACKGROUND_COLOR: 'rgba(255, 255, 255, 0.9)',
      // BACKGROUND_COLOR: 'rgba(0, 51, 160, 0.85)',
      ACTION_COLOR: 'primary',
      // ACTION_COLOR: 'textSecondary',
    },
    PALETTE: {
      primary: {
        main: '#FA6400',
        light: '#FEE0CC',
      },
      secondary: {
        main: '#A84308',
        contrastText: '#FFF',
      },
      background: {
        default: '#F1F3F8',
        paper: '#FFF',
      },
      text: {
        primary: '#000',
        // primary: '#FA6400',
        secondary: '#4D4D4D',
        // secondary: '#2B2B2B',
        disabled: '#6A6A6A',
      },
    },
  },
  PATAGONIA: {
    ...common,
    LOGIN_PAGE: LoginPatagonia,
    REGISTER_PAGE: null,
  },
};

type AppConfig = (typeof config)['SURA' | 'ANSWER'];

// TODO: change uppercase name by lowercase to match with mobile apps. Replacing "SURA" by "sura".
export const appConfig: AppConfig =
  config[process.env.REACT_APP_WEBSITE || 'SURA'];
